<template>
  <div class="job-notes" id="job-notes-window" :class="{ show: show }">
    <div class="job-notes-content">
      <div class="job-notes-heading">
        <fieldset>
          <legend class="d-flex justify-content-between">
            Notes

            <div>
              <button
                type="button"
                class="btn btn-primary btn-xs"
                @click="close"
              >
                <i class="material-icons">
                  cancel
                </i>
              </button>
            </div>
          </legend>
        </fieldset>

        <fieldset>
          <legend>New Note</legend>
          <div class="notes-input">
            <input-block
              placeholder="Note..."
              :stacked="true"
              name="note"
              v-model="form.body"
            ></input-block>
          </div>

          <form-button :indicator="form.processing()" v-on:clicked="save">
            Save Note
          </form-button>
        </fieldset>
      </div>

      <div class="job-notes-body">
        <div class="note" v-for="(note, index) in job.notes" :key="index">
          <p v-html="note.body"></p>

          <strong>
            {{ note.user?.full_name }} |
            {{ note.created_at | date('DD/MM/YYYY HH:mm') }} |
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    job: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },

  data() {
    return {
      form: new window.Form(
        {
          body: ''
        },
        true
      ),
      sidebar: null
    };
  },

  mounted() {
    const notes = document.getElementById('job-notes-window');

    if (notes) {
      this.sidebar = new window.Ps(notes);
    }
  },

  updated() {
    if (this.sidebar) {
      this.sidebar.update();
    } else {
      const notes = document.getElementById('job-notes-window');

      if (notes) {
        this.sidebar = new window.Ps(notes);
      }
    }
  },

  methods: {
    save() {
      this.form
        .post(`/jobs/${this.job.identifier}/notes`)
        .then(data => {
          this.$emit('saved', data);

          window.toastify.success('Saved!', 'The note was saved successfully');
        })
        .catch(err => {
          console.error(err);

          window.toastify.error(
            'Error',
            'An error occurred while saving the note'
          );
        });
    },

    close() {
      this.$emit('closed');
    }
  },

  watch: {
    job(changed) {}
  }
};
</script>

<style lang="scss">
.job-notes {
  position: fixed;
  z-index: 10;
  transition: all 0.5s ease;
  top: 0;
  right: 0;
  width: 0;
  background-color: #ffffff;
  height: 100%;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12), 0 1px 6px 0 rgba(0, 0, 0, 0.12);
  border-left: 1px solid #d3e0e9;
  overflow: hidden;

  .job-notes-content {
    width: 100vw;
    padding: 30px;
    display: flex;
    flex-direction: column;

    .job-notes-heading {
      flex-grow: 0;
      border-bottom: 1px solid #d3e0e9;
      padding-bottom: 15px;
      margin-bottom: 15px;
    }

    .job-notes-body {
      flex-grow: 1;
      overflow-y: scroll;
      height: 100%;

      .note {
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12),
          0 1px 6px 0 rgba(0, 0, 0, 0.12) !important;
        padding: 15px;
        border: 1px solid #d3e0e9;
        margin-bottom: 25px;
      }
    }

    .notes-input {
      .form-group {
        display: block;
      }

      textarea {
        width: 100%;
        height: 80px;
      }
    }
  }

  &.show {
    width: 100%;
  }

  @media (min-width: 768px) {
    .job-notes-content {
      width: 700px;
    }

    &.show {
      width: 700px;
    }
  }
}
</style>
